import React from 'react';
import './MgyLoading.css'

export default function MgyLoading() {
	return <div className="loadingio-spinner-interwind-3tde50b1qso">
		<div className="ldio-2o1chkt5ksl">
			<div>
				<div>
					<div>
						<div></div>
					</div>
				</div>
				<div>
					<div>
						<div></div>
					</div>
				</div>
			</div>
		</div>
	</div>
};

